import {Sky, Float, Text, ScrollControls, useGLTF } from "@react-three/drei"
import { useEffect } from 'react'
import * as THREE from 'three'

import Scene from './Components/Scene.jsx'
import Ocean from "./Components/Ocean.jsx"
import CameraScroll from './Components/CameraScroll.jsx'

import "./App.css";
import ScrollHelper from "./Components/ScrollHelper.jsx";

export default function App() {

  const { nodes } = useGLTF('./Model/House.glb?v=2')
  
  // Applica colori arancioni ai testi LANGIO e HOUSE
  useEffect(() => {
    if (!nodes) return
    
    // Colore arancione/oro (RGB: 184, 134, 11)
    const orangeColor = new THREE.Color(184/255, 134/255, 11/255)
    
    // Applica il colore ai mesh LANGIO e HOUSE
    const meshNames = ['LANGIO', 'Testo', 'Testo.001', 'Testo.002', 'Testo.003', 'HOUSE']
    
    meshNames.forEach(meshName => {
      if (nodes[meshName]) {
        const mesh = nodes[meshName]
        if (mesh.geometry) {
          // Crea un materiale arancione per il testo
          const material = new THREE.MeshStandardMaterial({
            color: orangeColor,
            metallic: 0,
            roughness: 0.5,
            emissive: new THREE.Color(80/255, 60/255, 5/255), // Emissione leggera
          })
          mesh.material = material
        }
      }
    })
  }, [nodes])
  
  return (
    <>
      <directionalLight position={ [1, 2, 3] } intensity={ 2.5 }/>

      <Ocean/>
      <Sky sunPosition={[1, 0.1, 1]}/>
      
      <Float rotationIntensity={0.9}>
          <Text
            font="./fonts/font.ttf"
            position-y={ 15 }
            rotation-y={ 0.48 * Math.PI }
            curveRadius={ -50 }
            fontSize={ 5 }
          >
            LANGIO's World
        </Text>
      </Float>

      <Scene nodes= { nodes }/>
     
          
      <ScrollControls pages={25} damping={0.2}>    
        <CameraScroll nodes= { nodes }/>
      </ScrollControls>

      <ScrollHelper/>
      
    </>
  )
}

useGLTF.preload('./Model/House.glb?v=2')
